import EnquiryForm from './enquiries/enquiry-form/EnquiryCreateWizard'
import Enquiries from './enquiries/Enquiries'
import { withTitle } from './BrowserTitle'
import EnquiryLodgementWizard from './enquiries/enquiry-form/EnquiryLodgementWizard'
import EnquiryLanding from './enquiries/enquiry-details/EnquiryLanding'
import MyProfile from './myprofile/MyProfile'
import ResetPin from './pin/ResetPin'
import FindMyAwardWizard from './awards/find-my-award/FindMyAwardWizard'
import Awards from './mybookmarks/awards/Awards'
import Results from './mybookmarks/results/Results'
import Pages from './mybookmarks/pages/Pages'
import ResetPassword from './resetpassword/ResetPassword'
import BookmarkToMyAccount from './mybookmarks/bookmarks/BookmarkToMyAccount'
import Bookmarks from './mybookmarks/bookmarks/Bookmarks'
import FeedbackLanding from './feedback/FeedbackLanding'
import GetHelpLanding from './gethelp/GetHelpLanding'
import UnpaidWagesLanding from './wages/UnpaidWagesLanding'
import FormsLanding from './interactivetemplate/FormsLanding'
import WorkplaceBasicsLanding from './workplacebasics/WorkplaceBasicsLanding'
import Resources from './resources/Resources'
import DisableUser from './disable/DisableUser'
import EnquiryClose from './enquiries/enquiry-details/EnquiryClose'
import EnquiryCancel from './enquiries/enquiry-details/EnquiryCancel'
import ChangeUserEmailAddress from './changeUserEmail/ChangeUserEmail'
import EnquiryAbandon from './enquiries/enquiry-steps/EnquiryAbandon'
import ResetPasswordLanding from './resetpassword/ResetPasswordLanding'
import ChangeABN from './changeABN/ChangeABN'
import DeleteBookmarks from './mybookmarks/bookmarks/DeleteBookmarks'
// import ChangeMFAPhoneVerifyEmail from './ChangeMFAPhone/ChangeMFAPhoneVerifyEmail'
// import ChangeMFAPhoneLanding from './ChangeMFAPhone/ChangeMFAPhoneLanding'
// import ChangeMFAPhoneVerifySMS from './ChangeMFAPhone/ChangeMFAPhoneVerifySMS'
//import EnquiryRequestForInformationForm from './enquiries/enquiry-details/EnquiryRequestForInformationForm'
import EnquiryRequestForInformationLanding from './enquiries/enquiry-details/EnquiryRequestForInformationLanding'

export const FindMyAwardWithTitle = withTitle({
  component: FindMyAwardWizard,
  title: 'Find out which award covers you - Fair Work Ombudsman',
})

export const ResetPinWithTitle = withTitle({
  component: ResetPin,
  title: 'Profile - My account - Change PIN - Fair Work Ombudsman',
})

export const ChangeABNWithTitle = withTitle({
  component: ChangeABN,
  title: 'Profile - My account - Change business name (ABN) - Fair Work Ombudsman',
})
export const DisableUserWithTitle = withTitle({
  component: DisableUser,
  title: 'Profile - My account - Disable User - Fair Work Ombudsman',
})
export const ChangeUserEmailWithTitle = withTitle({
  component: ChangeUserEmailAddress,
  title: 'Profile - My account - Change user email - Fair Work Ombudsman',
})

export const ResetPasswordWithTitle = withTitle({
  component: ResetPassword,
  title: 'Profile - My account - Change Password - Fair Work Ombudsman',
})

export const ResetPasswordLandingWithTitle = withTitle({
  component: ResetPasswordLanding,
  title: 'Profile - My account - Change password - Fair Work Ombudsman',
})
// export const ChangeMFAPhoneVerifyEmailWithTitle = withTitle({
//   component: ChangeMFAPhoneVerifyEmail,
//   title: 'Profile - My account -  Verify email & new verification phone number - Fair Work Ombudsman',
// })
// export const ChangeMFAPhoneVerifySMWithTitle = withTitle({
//   component: ChangeMFAPhoneVerifySMS,
//   title: 'Profile - My account -  Verify SMS & submit the request - Fair Work Ombudsman',
// })
// export const ChangeMFAPhoneLandingWithTitle = withTitle({
//   component: ChangeMFAPhoneLanding,
//   title: 'Profile - My account - Change verification phone number landing - Fair Work Ombudsman',
// })
export const EnguiriesWithTitle = withTitle({
  component: Enquiries,
  title: 'Enquiries - My account - Fair Work Ombudsman',
})

export const SubmitEnquiryWithTitle = withTitle({
  component: EnquiryForm,
  title: 'Submit enquiry - My account - Fair Work Ombudsman',
})

export const ViewExistingEnquiryWithTitle = withTitle({
  component: EnquiryLodgementWizard,
  title: 'View existing enquiry - My account - Fair Work Ombudsman',
})

export const EnquiryRequestForInformationLandingWithTitle = withTitle({
  component: EnquiryRequestForInformationLanding,
  title: 'Enquiry details - My account - Request for more information',
})
export const EnquiryDetailsWithTitle = withTitle({
  component: EnquiryLanding,
  title: 'Enquiry details - My account - Fair Work Ombudsman',
})
export const EnquiryCloseWithTitle = withTitle({
  component: EnquiryClose,
  title: 'Enquiry details - My account - Close enquiry',
})

export const EnquiryCancelWithTitle = withTitle({
  component: EnquiryCancel,
  title: 'Enquiry details - My account - Cancel enquiry',
})

export const EnquiryAbandonWithTitle = withTitle({
  component: EnquiryAbandon,
  title: 'Enquiry details - My account - Abandon enquiry'
})

export const ProfileWithTitle = withTitle({
  component: MyProfile,
  title: 'Profile - My account - Fair Work Ombudsman',
})

export const ResourcesWithTitle = withTitle({
  component: Resources,
  title: 'Resources - My account - Fair Work Ombudsman',
})

export const BookmarToMyAccountWithTitle = withTitle({
  component: BookmarkToMyAccount,
  title: 'Bookmark to my account - My account - Fair Work Ombudsman',
})

export const BookmarkedAwardsWithTitle = withTitle({
  component: Awards,
  title: 'Bookmarked awards - My account - Fair Work Ombudsman',
})

export const BookmarkedResultsWithTitle = withTitle({
  component: Results,
  title: 'Bookmarked results - My account - Fair Work Ombudsman',
})

export const BookmarkedPagesWithTitle = withTitle({
  component: Pages,
  title: 'Bookmarked pages - My account - Fair Work Ombudsman',
})

export const BookmarksWithTitle = withTitle({
  component: Bookmarks,
  title: 'Bookmarks - My account - Fair Work Ombudsman',
})

export const DeleteBookmarksWithTitle = withTitle({
  component: DeleteBookmarks,
  title: 'Bookmarks delete - My account - Fair Work Ombudsman',
})

export const CreateFeedback = withTitle({
  component: FeedbackLanding,
  title: 'Feedback form - Fair Work Ombudsman',
})
export const GetHelpLandingWithTitle = withTitle({
  component: GetHelpLanding,
  title: 'Get help',
})
export const UnpaidWagesLandingWithTitle = withTitle({
  component: UnpaidWagesLanding,
  title:
    'Search for unpaid wages - Helping the community - Fair Work Ombudsman',
})
export const InteractiveTemplateMain = withTitle({
  component: FormsLanding,
  title: 'Generate documents from templates - Fair Work Ombudsman',
})

export const WorkplaceBasicsWithTitle = withTitle({
  component: WorkplaceBasicsLanding,
  title: 'Workplace basics - Fair Work Ombudsman',
})
